import React from 'react';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Markdown from '@repo/ui/src/components/Markdown';
import ProTipPigIcon from '@repo/ui/src/components/Icons/ProTipPigIcon';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { LinkProps } from '@typings/index';

type ProTipProps = {
  tip: string;
  link?: LinkProps;
};

const ProTip = ({ tip, link }: ProTipProps) => {
  const { t } = useTranslation();
  return (
    <div className="tw-w-full tw-col-span-2 tw-bg-warm-200 tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-py-6 tw-px-10 tw-mt-4">
      <div className="tw-flex tw-flex-row sm:tw-flex-col tw-items-center tw-w-full sm:tw-w-fit sm:tw-shrink-0">
        <ProTipPigIcon className='tw-w-12 sm:tw-w-full' />
        <span className="tra-text-web-sub-2 tw-ml-2 sm:tw-ml-0 tw-mt-0 tw-font-semibold tw-text-gray-800">
          {t('recipeContent.proTip', undefined, { default: 'Pro Tip' })}
        </span>
      </div>

      <div className="tw-w-full sm:tw-w-[3px] tw-h-[3px] sm:tw-h-auto sm:tw-self-stretch tw-bg-brand-300 sm:tw-mx-10 tw-mt-2 sm:tw-mt-0" />

      <div className="tw-flex-1 tw-mt-4 sm:tw-mt-0">
        <Markdown 
          className="tw-text-gray-900 " 
          bodySize="large"
          components={{
            a: (elProps: any) => {
              const isInternal = elProps.href?.startsWith('/') || elProps.href?.startsWith('#');
              return (
                <Anchor
                  className='tra-text-web-link hover:tw-text-brand-500'
                  externalLink={!isInternal ? elProps.href : undefined}
                  link={isInternal ? elProps.href : undefined}
                  isExternal={!isInternal}
                  {...elProps}
                />
              );
            },
          }}
        >
          {tip}
        </Markdown>
        {link?.displayName && (
          <div className="tw-mt-3">
            <Button variant={ButtonVariant.knife} as={Anchor} size="small" {...link}>
              {link.displayName}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProTip;
